// Base pagination class

import { Transform } from 'class-transformer';

import { ApiProperty } from '../codegen';
import { IsNumber, IsOptional } from '../validators';

export class BasePaginationDto {
  @IsNumber()
  @IsOptional()
  @Transform(({ value }) => Number(value))
  @ApiProperty()
  readonly page?: number = 1;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => Number(value))
  @ApiProperty()
  readonly take?: number = 20;
}
